import { z } from "zod";
/** A single turn in the transcript */
export const TranscriptEntrySchema = z.object({
    speaker: z.enum(["clinician", "patient", "other"]),
    text: z.string().min(1),
    start: z.number().optional(), // seconds
    end: z.number().optional(), // seconds
});
/** Full transcript schema */
export const TranscriptSchema = z.object({
    entries: z.array(TranscriptEntrySchema).min(1),
});
